import { render, staticRenderFns } from "./UploadedFileItem.vue?vue&type=template&id=2beb2ae4&scoped=true&"
import script from "./UploadedFileItem.vue?vue&type=script&lang=js&"
export * from "./UploadedFileItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileItem.vue?vue&type=style&index=0&id=2beb2ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb2ae4",
  null
  
)

export default component.exports